import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const anchors = [
  { href: '#tree', label: '生命樹' },
  { href: '#trilogy', label: '三部曲' },
  { href: '#start', label: '從這裡開始' },
  { href: '#initiator', label: '生命角色' },
  { href: '#library', label: '宇宙書信／書架' },
  { href: '#aum', label: '關於 AUM' },
];

const ogMenu = [
  { to: '/og/portal', label: '一之門簡介' },
  { to: '/mission/human-paradise', label: '母場人間天堂' },
  { to: '/og/qi-healing', label: '宇炁療育｜子場實作' },
  { to: '/og/qi-healing/witnesses', label: '見證牆' },
];

export default function AumHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [ogOpen, setOgOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-sm border-b border-foreground-100/60'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <nav className="max-w-6xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <a href="#top" className="flex items-baseline cursor-pointer whitespace-nowrap">
          <span
            className="text-base md:text-lg tracking-wide text-foreground-900"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            AUM1001 Matrix
          </span>
        </a>

        <div className="hidden md:flex items-center gap-0.5">
          {anchors.map((a) => (
            <a
              key={a.href}
              href={a.href}
              className="whitespace-nowrap px-3 py-2 text-sm text-foreground-600 hover:text-foreground-900 hover:bg-foreground-50 rounded-md transition-colors cursor-pointer"
            >
              {a.label}
            </a>
          ))}

          <Link
            to="/abaa-witness"
            className="whitespace-nowrap px-3 py-2 text-sm text-foreground-600 hover:text-foreground-900 hover:bg-foreground-50 rounded-md transition-colors cursor-pointer"
          >
            ABAA 見證
          </Link>

          {/* OG 一之門 下拉 */}
          <div
            className="relative"
            onMouseEnter={() => setOgOpen(true)}
            onMouseLeave={() => setOgOpen(false)}
          >
            <button
              className="whitespace-nowrap px-3 py-2 text-sm text-foreground-600 hover:text-foreground-900 hover:bg-foreground-50 rounded-md transition-colors cursor-pointer flex items-center gap-1"
            >
              OG 一之門
              <i className={`ri-arrow-down-s-line text-xs transition-transform ${ogOpen ? 'rotate-180' : ''}`} />
            </button>
            {ogOpen && (
              <div className="absolute top-full left-0 mt-1 w-52 bg-background-50 border border-foreground-200/60 rounded-lg shadow-sm py-1.5">
                {ogMenu.map((item) => (
                  <Link
                    key={item.to}
                    to={item.to}
                    className="block whitespace-nowrap px-4 py-2 text-sm text-foreground-600 hover:text-foreground-900 hover:bg-foreground-50 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                ))}
                <div className="mt-1 border-t border-foreground-100/60 pt-1 px-4 pb-1">
                  <p className="text-[10px] text-foreground-400">登入後可見更多入口</p>
                </div>
              </div>
            )}
          </div>

          <Link
            to="/revolving-gate"
            className="whitespace-nowrap px-4 py-2 text-sm rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer ml-1"
          >
            進入《1001旋轉門》
          </Link>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-700 cursor-pointer"
          aria-label="開啟選單"
        >
          <i className={`ri-${open ? 'close' : 'menu'}-line text-xl`} />
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-foreground-100/60 bg-background-50 px-4 py-3 flex flex-col gap-0.5 max-h-[75vh] overflow-y-auto">
          {anchors.map((a) => (
            <a
              key={a.href}
              href={a.href}
              onClick={() => setOpen(false)}
              className="px-3 py-2.5 rounded-md text-sm text-foreground-600 hover:bg-foreground-50 cursor-pointer whitespace-nowrap"
            >
              {a.label}
            </a>
          ))}

          <Link
            to="/abaa-witness"
            onClick={() => setOpen(false)}
            className="px-3 py-2.5 rounded-md text-sm text-foreground-600 hover:bg-foreground-50 cursor-pointer whitespace-nowrap"
          >
            ABAA 見證
          </Link>

          {/* OG 一之門（mobile 分組） */}
          <div className="mt-2 border-t border-foreground-100/60 pt-2">
            <p className="px-3 py-1 text-xs text-foreground-400 font-medium">OG 一之門</p>
            {ogMenu.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className="flex items-center gap-2 px-3 py-2.5 rounded-md text-sm text-foreground-600 hover:bg-foreground-50 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-flashlight-line text-base text-accent-500" />
                {item.label}
              </Link>
            ))}
            <p className="px-3 py-1 text-[10px] text-foreground-400">登入後可見：我的宇炁紀錄、施炁者工作台、Admin／Reviewer</p>
          </div>

          <Link
            to="/revolving-gate"
            onClick={() => setOpen(false)}
            className="px-3 py-2.5 rounded-md text-sm text-primary-800 bg-primary-100 cursor-pointer whitespace-nowrap mt-1"
          >
            進入《1001旋轉門》
          </Link>
        </div>
      )}
    </header>
  );
}
